import { CheckoutState } from '../state';
import { getQueryString, getUserAgent } from '../utils/browser';
import {
    getCaptchaV3Token,
    getCorrelationId,
    getGuestAgeAndId,
    getPlatformLabel,
    getRecaptcha3PublicKey,
    getRequestExtraMetadata,
    getRequestPath,
    getSessionId,
} from './app';
import { getEventOrganizationId } from './event';
import { getTicketsCostDetails } from './tickets/getDisplayCostProps';
import { getUserId, isUserLoggedIn } from './user';

export const getRiskGateMetadata = (state: CheckoutState) => {
    const { guestAge, guestId } = getGuestAgeAndId(state);
    const { httpReferer, ip, host, method } = getRequestExtraMetadata(state);

    const isPaid = getTicketsCostDetails(state).totalCostInCents > 0;

    return {
        captchaV3Token: getCaptchaV3Token(state),
        correlationId: getCorrelationId(state),
        guestAge,
        guestId,
        httpReferer,
        host,
        ipAddress: ip,
        isPaid,
        method,
        orgId: getEventOrganizationId(state),
        path: getRequestPath(state),
        platform: getPlatformLabel(state),
        queryString: getQueryString(),
        recaptchaSiteKey: getRecaptcha3PublicKey(state),
        sessionId: getSessionId(state),
        userAgent: getUserAgent(),
        userId: getUserId(state),
        userLoggedIn: isUserLoggedIn(state),
    };
};
